"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductListRequest = void 0;
var ProductListRequest = /** @class */ (function () {
    function ProductListRequest() {
    }
    return ProductListRequest;
}());
exports.ProductListRequest = ProductListRequest;
;
//# sourceMappingURL=productList.request.js.map